import { getBrandLogo } from '@/modules/integrations';

function getProviderLogoUrl(provider: string): string | null {
  return getBrandLogo(provider);
}

interface ProviderLogoProps {
  provider: string;
  size: number;
  fallbackBg?: string;
  fallbackColor?: string;
  borderRadius?: string | number;
  padding?: number;
}

export function ProviderLogo({
  provider,
  size,
  fallbackBg = 'var(--color-gray-300)',
  fallbackColor = 'var(--color-text-prose)',
  borderRadius = '50%',
  padding = 2,
}: ProviderLogoProps) {
  const logoUrl = getProviderLogoUrl(provider);

  const baseStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius,
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  };

  if (logoUrl) {
    return (
      <span style={{ ...baseStyle, background: 'var(--color-white)', border: '1px solid var(--color-gray-300)', padding }}>
        <img
          src={logoUrl}
          alt={provider}
          style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
        />
      </span>
    );
  }

  return (
    <span
      style={{
        ...baseStyle,
        background: fallbackBg,
        color: fallbackColor,
        fontSize: Math.round(size * 0.46),
        fontWeight: 700,
      }}
    >
      {(provider || '?').charAt(0).toUpperCase()}
    </span>
  );
}
